module.exports = __webpack_public_path__ + "static/img/portrait_en.0535589.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/world/elements/img/portrait_en.png
// module id = GLCp
// module chunks = 0